var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33326 1.99908L3.33326 13.9991C3.33365 14.1206 3.36715 14.2397 3.43018 14.3435C3.49321 14.4474 3.58337 14.5321 3.69097 14.5885C3.79856 14.645 3.9195 14.671 4.04079 14.6638C4.16207 14.6566 4.27909 14.6165 4.37926 14.5477L13.0459 8.54775C13.4053 8.29908 13.4053 7.70042 13.0459 7.45108L4.37926 1.45108C4.2793 1.38163 4.16222 1.3409 4.04073 1.33332C3.91925 1.32574 3.79801 1.3516 3.69019 1.40809C3.58237 1.46458 3.49209 1.54953 3.42917 1.65372C3.36624 1.75792 3.33307 1.87736 3.33326 1.99908ZM11.4953 7.99908L4.6666 12.7271L4.6666 3.27108L11.4953 7.99908Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.53fafeb435d598431496951273e87e8d.svg";
export { ForwardRef as ReactComponent };